import { useLocalizedMessage } from '../../../util/useLocalizedMessage';

const keyByName = {
  ACTIVE: 'merchandising.status.active',
  ARCHIVED: 'merchandising.status.archived',
  ADD_PRODUCT: 'merchandising.workbench.addProduct',
  ADD_RELATED_SEARCH: 'merchandising.workbench.addRelatedSearch',
  ADD_SEARCH: 'merchandising.workbench.addSearch',
  ADVANCED_OPTIONS: 'merchandising.workbench.advancedOptions',
  ALL_STATUSES: 'merchandising.workbench.allStatuses',
  APPLIES_TO: 'merchandising.workbench.appliesTo',
  ARRANGE_RESULTS_FOR: 'merchandising.workbench.arrangeResultsFor',
  BACK_TO_RANKING: 'merchandising.workbench.backToRanking',
  BACK_TO_RULES: 'merchandising.workbench.backToRules',
  BRANDS: 'merchandising.workbench.brands',
  CANCEL: 'merchandising.bulk.cancel',
  CLEAR: 'merchandising.workbench.clearDate',
  CATEGORIES: 'merchandising.workbench.categories',
  CATEGORY_DESCRIPTION: 'merchandising.categories.description',
  CATEGORY_PRIORITIES: 'merchandising.workbench.categoryPriorities',
  CHANGES: 'merchandising.workbench.changes',
  CLOSE: 'merchandising.transfer.close',
  CREATE_RANKING_RULE: 'merchandising.workbench.createRankingRule',
  CREATE_SEARCH_RULE: 'merchandising.workbench.createSearchRule',
  DISABLE: 'merchandising.action.disable',
  DISABLED: 'merchandising.status.disabled',
  DRAFT: 'merchandising.status.draft',
  DUPLICATE: 'merchandising.transfer.duplicate',
  EFFECT: 'merchandising.workbench.effect',
  ENDS: 'merchandising.workbench.ends',
  EMPTY_BODY: 'merchandising.workbench.emptyBody',
  EMPTY_HEADING: 'merchandising.workbench.emptyHeading',
  LOAD_ERROR: 'merchandising.workbench.loadError',
  RETRY: 'merchandising.action.retry',
  SCHEDULED: 'merchandising.schedule.scheduled',
  SUGGESTED: 'merchandising.status.suggested',
  HIGHER: 'merchandising.workbench.higher',
  LOWER: 'merchandising.workbench.lower',
  NORMAL: 'merchandising.workbench.priority.natural',
  SEPARATOR: 'merchandising.workbench.separator',
  TIMES: 'merchandising.workbench.multiplierSymbol',
  RESTORE: 'merchandising.workbench.restore',
  HIDE: 'merchandising.workbench.hide',
  UNPIN: 'merchandising.workbench.unpin',
  PIN_AFTER_CURRENT: 'merchandising.workbench.pinAfterCurrent',
  REORDER_PRODUCT: 'merchandising.workbench.reorderProduct',
  MOVE_EARLIER: 'merchandising.workbench.moveEarlier',
  MOVE_LATER: 'merchandising.workbench.moveLater',
  HIDDEN: 'merchandising.workbench.hidden',
  EXCLUDED_BY_GROUP: 'merchandising.workbench.excludedByGroup',
  HIDE_EXCLUDED: 'merchandising.workbench.hideExcluded',
  SHOW_EXCLUDED: 'merchandising.workbench.showExcluded',
  INCREASED: 'merchandising.workbench.increased',
  DECREASED: 'merchandising.workbench.decreased',
  NATURAL_ORDER: 'merchandising.workbench.naturalOrder',
  PRODUCTS_LOWER: 'merchandising.workbench.productsLower',
  EXCLUDED: 'merchandising.workbench.excluded',
  DONE: 'merchandising.workbench.done',
  EDIT_PRIORITY: 'merchandising.workbench.editPriority',
  DONE_EDITING: 'merchandising.workbench.doneEditing',
  EXCLUDE: 'merchandising.workbench.exclude',
  PRIORITY: 'merchandising.field.priority',
  PRIORITY_STRENGTH: 'merchandising.workbench.priorityStrength',
  NEXT_PAGE: 'merchandising.action.next',
  NO_PREVIEW_CHANGES: 'merchandising.workbench.noPreviewChanges',
  FIRST_PAGE: 'merchandising.workbench.firstPage',
  LAST_PAGE: 'merchandising.workbench.lastPage',
  OF: 'merchandising.workbench.of',
  PAGE: 'merchandising.workbench.page',
  PREVIEWING_SEARCH: 'merchandising.workbench.previewingSearch',
  PREVIEW_MODE: 'merchandising.workbench.previewMode',
  PREVIEW_DRAFT: 'merchandising.workbench.previewDraft',
  LIVE_RESULTS: 'merchandising.workbench.liveResults',
  ORIGINAL_RESULTS: 'merchandising.workbench.originalResults',
  CHANGES_ONLY: 'merchandising.workbench.changesOnly',
  PREVIEW_REFRESHING: 'merchandising.workbench.previewRefreshing',
  PREVIOUS_PAGE: 'merchandising.action.previous',
  PRODUCT_RANKING: 'merchandising.workbench.productRanking',
  PRODUCT_RANKING_DESCRIPTION: 'merchandising.library.product_ranking.description',
  PRODUCT_SEARCH: 'merchandising.workbench.productSearch',
  PUBLISH: 'merchandising.workbench.publish',
  QUERY: 'merchandising.workbench.query',
  RANKING_RULES_PLACEHOLDER: 'merchandising.workbench.rankingPlaceholder',
  RANKING_AUTONAME: 'merchandising.workbench.rankingAutoname',
  RELATED_SEARCH: 'merchandising.workbench.relatedSearch',
  RESET_CHANGES: 'merchandising.workbench.resetChanges',
  RESULTS_PHRASE: 'merchandising.workbench.resultsPhrase',
  RULE_SETTINGS: 'merchandising.workbench.ruleSettings',
  RESULT_GROUPS: 'merchandising.workbench.resultGroups',
  RESULT_GROUPS_HELP: 'merchandising.workbench.resultGroupsHelp',
  GROUP_PRIORITY_EXPLANATION: 'merchandising.workbench.groupPriorityExplanation',
  QUERY_VARIANT_HELP: 'merchandising.workbench.queryVariantHelp',
  SAME_CHANGES_APPLY: 'merchandising.workbench.sameChangesApply',
  RULE_AUTONAME: 'merchandising.workbench.ruleAutoname',
  REWRITE_HELP: 'merchandising.workbench.rewriteHelp',
  PRODUCT_SEARCH_HELP: 'merchandising.workbench.productSearchHelp',
  SEARCH_INSTEAD: 'merchandising.workbench.searchInstead',
  SEARCH_RESULTS: 'merchandising.workbench.searchResults',
  SCHEDULE: 'merchandising.field.schedule',
  SCHEDULE_ENABLED: 'merchandising.workbench.scheduleEnabled',
  NO_SCHEDULE: 'merchandising.workbench.noSchedule',
  STARTS: 'merchandising.workbench.starts',
  SEARCH_RULES: 'merchandising.workbench.searchRules',
  SEARCH_RULES_DESCRIPTION: 'merchandising.library.query_override.description',
  SEARCH_RULES_PLACEHOLDER: 'merchandising.workbench.searchRulesPlaceholder',
  SELECTED: 'merchandising.workbench.selected',
  SELECT_ALL: 'merchandising.workbench.selectAll',
  STATUS: 'merchandising.field.status',
  TEAM_NOTE: 'merchandising.workbench.teamNote',
  UPDATED: 'merchandising.field.updated',
};

export const useMerchandisingWorkbenchCopy = () => {
  const t = useLocalizedMessage();
  return Object.fromEntries(Object.entries(keyByName).map(([name, key]) => [name, t(key)]));
};

export default useMerchandisingWorkbenchCopy;
